import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
export const DashboardFloatingAlertStore = FloatingAlertStore.newFloatingAlertStore();
export const resetFloatingAlertStore = () => {
  const alerts = DashboardFloatingAlertStore.getAlerts();
  Object.keys(alerts).forEach(id => {
    DashboardFloatingAlertStore.removeAlert(id);
  });
};